import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import { LIFFQR } from '@/components/common/LIFFQR'

const errorSearchSchema = z.object({
  redirectUri: z.string().optional(),
})

export const Route = createFileRoute('/_liff/error/notInLine')({
  component: RouteComponent,
  validateSearch: errorSearchSchema,
})

function RouteComponent() {
  const { redirectUri = '/' } = Route.useSearch()

  return (
    <div className="flex min-h-dvh w-full items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <LIFFQR
          path={redirectUri}
          size={200}
        />
        <h1 className="text-2xl font-bold">แสกน QR Code</h1>
        <p className="text-center">กรุณาเปิดหน้านี้ใน LINE เพื่อใช้งาน</p>
      </div>
    </div>
  )
}
